import { jwtDecode } from "jwt-decode";
import { create } from "zustand";

interface AuthState {
  token: string | null;
  user: any | null;
  login: (token: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set: any) => ({
  token: localStorage.getItem("TOKEN"),
  user: null,
  login: (token: any) => {
    localStorage.setItem("TOKEN", token);
    set({ token, user: jwtDecode(token) });
  },
  logout: () => {
    localStorage.removeItem("TOKEN");
    set({ token: null, user: null });
  },
}));
